/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  CreateDeviceDto,
  DevicesControllerActivateV1PathParameters,
  DevicesControllerArchiveV1PathParameters,
  DevicesControllerChildrenV1PathParameters,
  DevicesControllerCreateV1PathParameters,
  DevicesControllerDeactivateV1PathParameters,
  DevicesControllerDeleteV1PathParameters,
  DevicesControllerExecuteActionV1PathParameters,
  DevicesControllerExecuteRemoteActionV1PathParameters,
  DevicesControllerFindAllV1Params,
  DevicesControllerFindAllV1PathParameters,
  DevicesControllerFindOneV1200,
  DevicesControllerFindOneV1PathParameters,
  DevicesControllerGetNotificationSubscriptionV1PathParameters,
  DevicesControllerPauseV1PathParameters,
  DevicesControllerTimeseriesV1PathParameters,
  DevicesControllerUpdateV1PathParameters,
  ExecuteActionDto,
  NotificationSubscriptionResponseDto,
  TimeseriesFilterDto,
  UpdateDeviceDto,
} from '../models';

@Injectable({ providedIn: 'root' })
export class DevicesService {
  private readonly http = inject(HttpClient);
  /**
   * @summary Get all devices for a client
   */

  findAll<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: DevicesControllerFindAllV1PathParameters,
    params: DevicesControllerFindAllV1Params,
  ): Observable<TData> {
    return this.http.get<TData>(`/devices/v1/clients/${clientId}/devices`, {
      params: (() => {
        const filteredParams: Record<string, string | number | boolean | Array<string | number | boolean>> = {};
        for (const [key, value] of Object.entries(params ?? {})) {
          if (Array.isArray(value)) {
            const filtered = value.filter(
              item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
            ) as Array<string | number | boolean>;
            if (filtered.length) {
              filteredParams[key] = filtered;
            }
          } else if (value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
            filteredParams[key] = value;
          }
        }
        return filteredParams;
      })(),
    });
  }
  /**
   * @summary Create a new device
   */

  create<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: DevicesControllerCreateV1PathParameters,
    createDeviceDto: CreateDeviceDto,
  ): Observable<TData> {
    return this.http.post<TData>(`/devices/v1/clients/${clientId}/devices`, createDeviceDto);
  }
  /**
   * @summary Authenticated user notification subscription status for this device incidents
   */

  getNotificationSubscription<TData = NotificationSubscriptionResponseDto>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    deviceId,
  }: DevicesControllerGetNotificationSubscriptionV1PathParameters): Observable<TData> {
    return this.http.get<TData>(`/devices/v1/clients/${clientId}/devices/${deviceId}/notification-subscription`);
  }
  /**
   * @summary Get details of a specific device
   */

  findOne<TData = DevicesControllerFindOneV1200>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    deviceId,
  }: DevicesControllerFindOneV1PathParameters): Observable<TData> {
    return this.http.get<TData>(`/devices/v1/clients/${clientId}/devices/${deviceId}`);
  }
  /**
   * @summary Delete a device
   */

  delete<TData = void>({ clientId = CURRENT_CLIENT_TEMPLATE_VAR, deviceId }: DevicesControllerDeleteV1PathParameters): Observable<TData> {
    return this.http.delete<TData>(`/devices/v1/clients/${clientId}/devices/${deviceId}`);
  }
  /**
   * @summary Get timeseries data for a device
   */

  timeseries<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, deviceId }: DevicesControllerTimeseriesV1PathParameters,
    timeseriesFilterDto: TimeseriesFilterDto,
  ): Observable<TData> {
    return this.http.post<TData>(`/devices/v1/clients/${clientId}/devices/${deviceId}/timeseries`, timeseriesFilterDto);
  }
  /**
   * @summary Get child devices for a specific device
   */

  children<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    deviceId,
  }: DevicesControllerChildrenV1PathParameters): Observable<TData> {
    return this.http.get<TData>(`/devices/v1/clients/${clientId}/devices/${deviceId}/children`);
  }
  /**
   * @summary Update device attributes
   */

  update<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, deviceId }: DevicesControllerUpdateV1PathParameters,
    updateDeviceDto: UpdateDeviceDto,
  ): Observable<TData> {
    return this.http.patch<TData>(`/devices/v1/clients/${clientId}/devices/${deviceId}/withAttributes`, updateDeviceDto);
  }
  /**
   * @summary Execute an action on a device
   */

  executeAction<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, deviceId, actionPointId }: DevicesControllerExecuteActionV1PathParameters,
    executeActionDto: ExecuteActionDto,
  ): Observable<TData> {
    return this.http.post<TData>(`/devices/v1/clients/${clientId}/devices/${deviceId}/execute/${actionPointId}`, executeActionDto);
  }
  /**
   * @summary Execute a remote action on a device
   */

  executeRemoteAction<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, deviceId, remoteActionPointId }: DevicesControllerExecuteRemoteActionV1PathParameters,
    executeActionDto: ExecuteActionDto,
  ): Observable<TData> {
    return this.http.post<TData>(
      `/devices/v1/clients/${clientId}/devices/${deviceId}/execute-remote/${remoteActionPointId}`,
      executeActionDto,
    );
  }
  /**
   * @summary Pause a device
   */

  pause<TData = void>({ clientId = CURRENT_CLIENT_TEMPLATE_VAR, deviceId }: DevicesControllerPauseV1PathParameters): Observable<TData> {
    return this.http.post<TData>(`/devices/v1/clients/${clientId}/devices/${deviceId}/pause`, undefined);
  }
  /**
   * @summary Activate a device
   */

  activate<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    deviceId,
  }: DevicesControllerActivateV1PathParameters): Observable<TData> {
    return this.http.post<TData>(`/devices/v1/clients/${clientId}/devices/${deviceId}/activate`, undefined);
  }
  /**
   * @summary Archive a device
   */

  archive<TData = void>({ clientId = CURRENT_CLIENT_TEMPLATE_VAR, deviceId }: DevicesControllerArchiveV1PathParameters): Observable<TData> {
    return this.http.post<TData>(`/devices/v1/clients/${clientId}/devices/${deviceId}/archive`, undefined);
  }
  /**
   * @summary Deactivate a device
   */

  deactivate<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    deviceId,
  }: DevicesControllerDeactivateV1PathParameters): Observable<TData> {
    return this.http.post<TData>(`/devices/v1/clients/${clientId}/devices/${deviceId}/deactivate`, undefined);
  }
}
